import clsx from 'clsx';
import React from 'react';

import styles from '../contractDetails.module.scss';

interface EntityNodeProps {
  data: {
    label: string;
    fields?: Record<string, any>;
  };
}

export function EntityNode( { data }: EntityNodeProps ) {
  return (
    <div className={ styles.entityNode }>
      <div className={ styles.entityHeader }>
        { data.label }
      </div>
      <div className={ styles.entityFields }>
        { data.fields && Object.entries( data.fields ).map( ( [ fieldName, field ]: [ string, any ] ) => {
          const isPrimary = field.primary;
          const isRequired = field.required;
          return (
            <div key={ fieldName } className={ clsx( styles.entityField, { [styles.primaryKey]: isPrimary } ) }>
              <span className={ styles.fieldName }>{ fieldName }</span>
              <span className={ styles.fieldType }>{ field.type || 'string' }</span>
              { isPrimary && <span className={ styles.keyBadge }>PK</span> }
              { isRequired && !isPrimary && <span className={ styles.requiredBadge }>*</span> }
            </div>
          );
        } ) }
      </div>
    </div>
  );
}
